import * as constants from "../constants/index";
import environments from "../environments";

import storageManager from "@/lib/storageManager";

export const fetchNotificationsSummary = () => {
  const endpoint = `${environments.API_BASE_URI}/notifications/summary`;
  const storedLargestProgressNotificationIdsString = storageManager.getConstructionItem(
    "PROGRESS_NOTIFICATION_FETCHED_LARGEST_ID"
  );
  let latestProgressNotificationId = 0;
  if (storedLargestProgressNotificationIdsString) {
    const storedLargestProgressNotificationIds: { [key: string]: number } = JSON.parse(
      storedLargestProgressNotificationIdsString
    );
    latestProgressNotificationId = Math.max(...Object.values(storedLargestProgressNotificationIds));
  }
  const query = `?latest_progress_notification_id=${latestProgressNotificationId}`;

  return {
    type: constants.APP_CALL_API,
    endpoint: `${endpoint}${query}`,
    method: "GET",
    callbacks: {
      begin: () => {
        return {
          type: constants.NOTIFICATIONS_BEGIN_FETCH_SUMMARY,
        };
      },
      success: (response) => {
        return {
          type: constants.NOTIFICATIONS_END_FETCH_SUMMARY,
          payload: response,
        };
      },
      error: (response) => {
        return {
          type: constants.APP_SHOW_ERROR,
          payload: response,
          error: true,
        };
      },
    },
  };
};
